import React, { useLayoutEffect } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { clearManualVoucherServiceTypes, getManualVoucherServiceTypes } from "../../../../actions/accounting/ManualVoucherServiceType";

export const ManualVoucherServiceTypeSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearManualVoucherServiceTypes,
  dispatchGetManualVoucherServiceTypes,
  ...rest
}) => {

  useLayoutEffect(() => {
    dispatchGetManualVoucherServiceTypes();
    return () => dispatchClearManualVoucherServiceTypes()
  }, []);

  const filterOption = (items) => items;

  return (
    <Select
      options={filterOption(options)}
      isLoading={loading}
      isMulti={isMulti}
      isClearable={isClearable}
      {...rest}
    />
  )
}

ManualVoucherServiceTypeSelect.propTypes = {
  loading: PropTypes.bool,
  options: optionsPropTypes,
  isGridVariant: PropTypes.bool,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  onValueChange: PropTypes.func,
  dispatchClearManualVoucherServiceTypes: PropTypes.func.isRequired,
  dispatchGetManualVoucherServiceTypes: PropTypes.func.isRequired,
}

ManualVoucherServiceTypeSelect.defaultProps = {
  loading: false,
  options: [],
  isGridVariant: false,
  isMulti: false,
  isClearable: false,
  onValueChange: undefined,
}

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: AccountingUnit.ManualVoucherServiceType.getIn(['all', 'loading']),
  options: AccountingUnit.ManualVoucherServiceType.getIn(['all', 'content']).toJS()
    .map(({ name, type, manualVoucherDetraction }) => ({
      label: name,
      value: type,
      manualVoucherDetraction
    })),
})

const mapDispatchToProps = {
  dispatchClearManualVoucherServiceTypes: clearManualVoucherServiceTypes,
  dispatchGetManualVoucherServiceTypes: getManualVoucherServiceTypes,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManualVoucherServiceTypeSelect);